<template>
    <div class="d-flex">
        <router-link to="/" class="logo-black"/>
    </div>
</template>

<script>
export default {
  name: 'Logo'
}
</script>



// WEBPACK FOOTER //
// src/front/components/pages/layout/default/Logo.vue